import { Pipe, PipeTransform } from '@angular/core';
import { UserSettingsFacade } from 'app/store/user-settings.facade';
import { map, Observable, take } from 'rxjs';

@Pipe({
  name: 'checkOwnerPermissions'
})
export class CheckOwnerPermissionsPipe implements PipeTransform {

  constructor (private _userSettingsFacade$: UserSettingsFacade) {}


  transform(userId: number): Observable<boolean> {
    return this._userSettingsFacade$._userSettings$.pipe(
      take(1),
      map(userSettings => userSettings.id === userId)
    )
  }

}
